import { useEffect } from 'react';
import { getUserContext, isFaroInitialized, setUserContext } from 'App/services/faroService';
import { getUserId, useIsLoggedIn } from 'App/services/idpTokenService';

/**
 * Hook to use Faro for user tracking
 */
const useSetupFaroUser = () => {
  const isLoggedIn = useIsLoggedIn();
  const faroInitialized = isFaroInitialized();

  // Set user context on userId change
  useEffect(() => {
    const userId              = getUserId(true);
    const existingUserContext = getUserContext();

    if (!userId || !faroInitialized) {
      return;
    }

    if (String(userId) === String(existingUserContext?.id)) {
      return;
    }

    setUserContext(userId);
  }, [isLoggedIn, faroInitialized]);
};

export default useSetupFaroUser;